import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { getAnalytics } from 'firebase/analytics'

// TODO: Replace the following with your app's Firebase project configuration
// See: https://support.google.com/firebase/answer/7015592
const firebaseConfig = {
    apiKey: process.env.REACT_APP_APIKEY,
    authDomain: process.env.REACT_APP_AUTHDOMAIN,
    databaseURL: process.env.REACT_APP_DBURL,
    projectId: process.env.REACT_APP_PROJECTID,
    storageBucket: process.env.REACT_APP_STORAGE,
    messagingSenderId: process.env.REACT_APP_MESSEGE,
    appId: process.env.REACT_APP_APIID,
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
getAnalytics(app);


// Initialize Cloud Firestore and get a reference to the service
export const db = firebase.firestore(app);
